import { nightModeStyleWhite } from "../publicFunctions/publicHelpers/helpers";

function PrivacyPolicy({ nightMode }) {
  return (
    <div className={nightMode ? "hero-background--black" : "hero-background"}>
      <div style={nightMode ? nightModeStyleWhite : {}} className="container">
        <h1
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-primary"
        >
          Code of Conduct
        </h1>
        <br />
        <br />
        <br />
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          No Harassment or Discrimination
        </h2>
        <p className="description margin-bottom-sm">
          We will not tolerate harassment of any kind, including but not limited
          to a member's sex, gender, race, or sexual orientation. Additionally,
          we will not tolerate passive-aggressive behaviour toward an author if
          it's clear to our admin team that comments are not being made in good
          faith. This includes public blogs or if the bullying continues off the
          platform via other forms of communication. If it is brought to Writing
          Battle's attention that a public blog denigrates other stories or
          authors from the community, the author's Writing Battle account may be
          removed.
        </p>
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          No Politics or Religion
        </h2>
        <p className="description margin-bottom-sm">
          Politics and religion are not topics to be discussed on the Forum or
          in feedback, but can be presented in stories. In your feedback,
          responses to politics or religion must focus solely on their
          presentation in the story, not on assumptions about the author or your
          own personal religious or political views.
        </p>
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          Respect Your Fellow Writers and Readers
        </h2>
        <p className="description margin-bottom-sm">
          Writing and reading are both very personal endeavors. If someone has
          an emotional or personal response to your story and you cannot respond
          in a respectful way, then simply don't respond. An author can delete
          any comment under their own story for any reason. If an author deletes
          one of your comments, then do not post another comment. On the Forum,
          respect the other members in that space.
        </p>
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          Respect the Moderators and Admin Team
        </h2>
        <p className="description margin-bottom-sm">
          There are a lot of opinions on how the contest should be run. Issues
          with the contest format, administrative actions, or moderators should
          not be discussed on the Forum and instead emailed to the admin team.
          Writing Battle appreciates any constructive feedback. If you wish to
          leave, please do so respectfully toward the moderators, admins, and
          other writers on the platform. Member consequences are considered
          private and will not be discussed openly on the platform.
        </p>
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          No Author Shaming
        </h2>
        <p className="description margin-bottom-sm">
          Authors are free to write the story that they want to tell regardless
          of the author's race, sexual orientation, gender, or sex. If a story
          violates the Story Restrictions, report it to an admin and do not
          engage with the author.
        </p>
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          Respect Member Privacy
        </h2>
        <p className="description margin-bottom-sm">
          Members of Writing Battle must respect the privacy of other members on
          the platform. This includes their names, images, story titles, and
          story content. These stories are not considered published. They are on
          a private platform and behind a username, password, and paywall, so
          you may not publish opinions about the authors or stories off of the
          platform without the permission of the author.
        </p>
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          General Forum Rules:
        </h2>
        <ul className="description">
          <li>
            Do not mention any specific story detail from stories you've judged
            when criticizing writing/story elements.
          </li>
          <li>Do not create duplicate posts.</li>
          <li>
            Do not sell anything. Self-promotion is allowed only if the content
            is not behind a subscription or paywall.
          </li>
          <li>
            Do not pile on. If the point has already been made and the
            conversation has run its course, then you don't have to contribute.
          </li>
          <li>Do not make any assumptions about another member.</li>
          <li>
            Do not reveal anything about your story other than Genre if you are
            participating in a Peer-Judged Battle.
          </li>
          <li>
            Off the Forum, do not make any public social media post or blog
            containing details about your story other than Genre before the
            judging is complete.
          </li>
        </ul>
        <br />
        <br />
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          Story Restrictions
        </h2>
        <p className="description">
          The following are some categories of stories that would be banned from
          our platform. We reserve the right to disqualify stories and/or ban
          authors that violate any of these restrictions.
        </p>
        <ol className="description">
          <li>
            Stories that glorify racism or sexism, or celebrate the
            discrimination against LGBTQ+ individuals or other marginalized
            groups.
          </li>
          <li>
            Stories containing overly graphic sexual content or
            extreme/excessive gore.
          </li>
          <li>
            Stories that would be illegal in the USA or Canada, including but
            not limited to the sexualization of minors, and incitement to
            violence or terrorism.
          </li>
          <li>
            Stories written with little to no effort or that were clearly
            generated using AI, as determined by our admin team.
          </li>
          <li>
            Stories revealing the author's identity or details about any Writing
            Battle community member.
          </li>
          <li>
            Stories containing intellectual property (IP) that the author does
            not own (e.g., 'fan fiction'). However, authors may use IP from
            creative works if they are in the public domain. For example,
            writing a spin on Little Red Riding Hood would be perfectly
            acceptable.
          </li>
          <li>
            Stories that were written or published before the Battle starts.
            However, characters and worlds from previous stories may be used if
            Writing Battle judges are unlikely to recognize them.
          </li>
        </ol>
        <br />
        <br />
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          Content Warnings Are Mandatory
        </h2>
        <p className="description margin-bottom-sm">
          Authors must select applicable content warnings from a provided list
          when submitting their stories.
        </p>
        <h2
          style={nightMode ? nightModeStyleWhite : {}}
          className="heading-secondary margin--none"
        >
          No Words Are Off-Limits
        </h2>
        <p className="description margin-bottom-sm">
          Though certain story types come with restrictions, no individual words
          are banned.
        </p>
        <br />
        <br />
        <p className="description margin-bottom-sm center-text bold">
          Writing Battle reserves the right to moderate forum posts, temporarily
          freeze accounts, or issue permanent bans when rules are violated.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
